<template>
	<div style="overflow: clip;">
		<header>
			<NavBar />
			<HeroBanner />
		</header>
		<main>
			<div class="container">
				<slot />
			</div>
		</main>
		<Footer />
	</div>
</template>
